// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @deprecated: this file is about to be removed */
.n-action-sort {
  color: color-mix(in srgb, var(--color-content-secondary) 15%, transparent);
}
*:hover > .n-action-sort {
  color: color-mix(in srgb, var(--color-content-secondary) 40%, transparent);
}
.n-action-sort__arrow--selected {
  color: var(--color-content-secondary);
}
*:hover > .n-action-sort--disabled {
  color: color-mix(in srgb, var(--color-content-secondary) 15%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/actions/SortAction/SortAction.less"],"names":[],"mappings":"AAAA,mDAAmD;AAGnD;EACE,0EAAA;AADF;AAGE;EACE,0EAAA;AADJ;AAKI;EACE,qCAAA;AAHN;AAQI;EACE,0EAAA;AANN","sourcesContent":["@import \"~neptune-core-ui/less/variables.less\";\n\n\n.n-action-sort {\n  color: @TableAction-color;\n\n  *:hover > & {\n    color: @TableAction-hover-color;\n  }\n\n  &__arrow {\n    &--selected {\n      color: @TableAction-active-color;\n    }\n  }\n\n  &--disabled {\n    *:hover > & {\n      color: @TableAction-color;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
